const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              
              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  } 
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();                                    
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
colorSwatches();
})()

/* Quick add on product cards — see snippets/card-quick-add.liquid.
   Phone / touch: the "+" on the photo opens one shared bottom sheet of sizes (.cqa-sheet, built here on first use).
   Desktop (hover devices ≥750px): the size bar over the photo is pure CSS; this only handles the clicks.
   Adds the same way the theme's product form does (same cart drawer, same variant:add / cart:change events for tracking).
   Lives in product-card.js, not its own asset, because theme.liquid loads this file on every page and cards injected later
   (You may also like, Recently viewed) do not execute inline <script> tags. */
if (!customElements.get('card-quick-add')) {
  class CardQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      this.status = this.querySelector('.cqa__status');
      this.bar = this.querySelector('.cqa__bar');
      this.plus = this.querySelector('.cqa__plus');
      const card = this.closest('.card-wrapper, .pc-card');
      if (card) card.classList.add('has-cqa'); // hides the old size links under the price (fallback for browsers without :has)
      this.addEventListener('click', (evt) => {
        if (evt.target.closest('.cqa__plus')) {
          evt.preventDefault();
          evt.stopPropagation();
          this.onPlus();
          return;
        }
        const btn = evt.target.closest('button.cqa__size');
        if (!btn) return;
        evt.preventDefault();
        evt.stopPropagation();
        this.add(btn, { status: this.status, focusEl: btn });
      });
    }

    onPlus() {
      const sizes = this.bar ? this.bar.querySelectorAll('.cqa__size') : [];
      // one-size product: the + adds straight away, no sheet
      if (sizes.length === 1 && sizes[0].tagName === 'BUTTON') {
        this.add(sizes[0], { status: this.status, focusEl: this.plus, indicator: this.plus });
        return;
      }
      CardQuickAdd.sheet().open(this);
    }

    /* Adds one variant. `indicator` gets the loading/added state (defaults to the button), `status` shows errors,
       `focusEl` is what the cart drawer returns focus to. Resolves true when the item went into the cart. */
    add(btn, opts) {
      opts = opts || {};
      const indicator = opts.indicator || btn;
      const status = opts.status || this.status;
      if (this.busy) return Promise.resolve(false);
      this.busy = true;
      status.textContent = '';
      indicator.classList.add('is-loading');
      indicator.setAttribute('aria-busy', 'true');

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const formData = new FormData();
      formData.append('id', btn.dataset.variantId);
      formData.append('quantity', '1');
      if (cart && cart.getSectionsToRender) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement && cart.setActiveElement(opts.focusEl || btn);
      }
      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      let added = false;
      return fetch(addUrl, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(new CustomEvent('cart:error', { detail: { source: 'card-quick-add', productVariantId: btn.dataset.variantId, errors: response.description, message: response.message } }));
            status.textContent = response.description || response.message || 'Could not add. Please try again.';
            return;
          }
          added = true;
          if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }

          document.dispatchEvent(new CustomEvent('variant:add', { detail: { variant: { id: btn.dataset.variantId }, quantity: 1, formElement: null, sectionId: 'card-quick-add' } }));
          fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`)
            .then((r) => r.json())
            .then((state) => document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: state, sectionId: 'card-quick-add' } })))
            .catch(() => {});
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'card-quick-add', productVariantId: btn.dataset.variantId });
          }

          indicator.classList.add('is-added');
          setTimeout(() => indicator.classList.remove('is-added'), 1500);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        })
        .catch(() => { status.textContent = 'Could not add. Please try again.'; })
        .finally(() => {
          indicator.classList.remove('is-loading');
          indicator.removeAttribute('aria-busy');
          this.busy = false;
          if (status.textContent) setTimeout(() => { status.textContent = ''; }, 4000);
        })
        .then(() => added);
    }

    /* One bottom sheet for the whole page, appended to <body> so card overflow:hidden cannot clip it. */
    static sheet() {
      if (CardQuickAdd._sheet) return CardQuickAdd._sheet;
      const root = document.createElement('div');
      root.className = 'cqa-sheet';
      root.hidden = true;
      root.innerHTML =
        '<div class="cqa-sheet__backdrop" data-cqa-close></div>' +
        '<div class="cqa-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="cqa-sheet-title">' +
          '<div class="cqa-sheet__head"><div class="cqa-sheet__heading"><span class="cqa-sheet__kicker">Select size</span><h2 class="cqa-sheet__title" id="cqa-sheet-title"></h2></div>' +
          '<button type="button" class="cqa-sheet__close" data-cqa-close aria-label="Close"><svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg></button></div>' +
          '<div class="cqa-sheet__list"></div>' +
          '<p class="cqa-sheet__status" role="status" aria-live="polite"></p>' +
        '</div>';
      const sheet = {
        root,
        title: root.querySelector('.cqa-sheet__title'),
        list: root.querySelector('.cqa-sheet__list'),
        status: root.querySelector('.cqa-sheet__status'),
        card: null,
        open(card) {
          this.card = card;
          // From inside the cart drawer the sheet must live inside #CartDrawer: the drawer traps focus there and sits at z-index 1000.
          // The drawer re-renders its HTML on every cart change, so re-attach on each open (the previous host may be gone).
          const host = card.closest('#CartDrawer') || document.body;
          if (root.parentNode !== host) host.appendChild(root);
          this.title.textContent = card.dataset.title || '';
          this.status.textContent = '';
          this.list.innerHTML = '';
          card.bar.querySelectorAll('.cqa__size').forEach((el) => this.list.appendChild(el.cloneNode(true)));
          root.hidden = false;
          document.body.classList.add('cqa-sheet-open');
          requestAnimationFrame(() => root.classList.add('is-open'));
          const first = this.list.querySelector('button.cqa__size') || this.list.querySelector('.cqa__size');
          if (first) first.focus({ preventScroll: true });
          document.addEventListener('keydown', this.onKey);
        },
        close() {
          const card = this.card;
          this.card = null;
          root.classList.remove('is-open');
          document.body.classList.remove('cqa-sheet-open');
          document.removeEventListener('keydown', this.onKey);
          setTimeout(() => { if (!this.card) root.hidden = true; }, 250);
          if (card && card.plus && !document.body.classList.contains('overflow-hidden')) card.plus.focus({ preventScroll: true });
        },
        onKey: null,
      };
      sheet.onKey = (evt) => { if (evt.key === 'Escape') sheet.close(); };
      root.addEventListener('keyup', (evt) => { if (evt.key === 'Escape') evt.stopPropagation(); }); // Escape closes the sheet only, not the cart drawer behind it
      root.addEventListener('click', (evt) => {
        if (evt.target.closest('[data-cqa-close]')) { sheet.close(); return; }
        const btn = evt.target.closest('button.cqa__size');
        if (!btn || !sheet.card) return;
        evt.preventDefault();
        sheet.card.add(btn, { status: sheet.status, focusEl: sheet.card.plus }).then((ok) => { if (ok) sheet.close(); });
      });
      CardQuickAdd._sheet = sheet;
      return sheet;
    }
  }
  customElements.define('card-quick-add', CardQuickAdd);
}